import cookie from 'cookie'
var URL = require('url').URL;

export const actions = {
  async nuxtServerInit({ commit, dispatch }, { req }) {
    try {
      const url = !req.headers.referer ? new URL(`https://${req.headers.host}`) : new URL(req.headers.referer)
      await dispatch('data/GET_GLOBAL_MESSAGES', url.origin)
      const token = cookie.parse(req.headers.cookie)['token']

      if (token) {
        const { data } = await dispatch('auth/checkToken', token)
        commit('auth/SET_USER', data.user)
        commit('auth/SET_LOGIN', data.logedIn)
        commit('auth/SET_TOKEN', token)
      }
    } catch (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./store/index.js